export default {
  id: 'posterPaymentModal',
  code: 'CN',
  text: {
    'Register': '报名',
    'Please Use WeChat Scan Pay': '请使用微信扫码支付',
    'Payment Successful': '扫码已完成，支付成功',
    'Complete': '完成',
    '': '',

  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/weChatPosterPayment/locale.js